import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "head p-4 bg-gradient-to-r from-blue-800 to-blue-700 border-b border-blue-900 shadow-md" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "px-4 pt-4" }
const _hoisted_4 = { class: "flex-1 overflow-y-auto p-4 space-y-3" }
const _hoisted_5 = {
  key: 0,
  class: "text-center py-8 text-gray-500"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex justify-between items-start" }
const _hoisted_8 = { class: "font-medium text-gray-900 mb-1 truncate pr-8" }
const _hoisted_9 = { class: "text-sm text-gray-500" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
}
const _hoisted_12 = { class: "bg-white rounded-lg p-6 max-w-sm mx-auto" }
const _hoisted_13 = { class: "flex justify-end space-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chat-history-list absolute top-0 right-0 bottom-0 bg-white transform transition-all duration-300 ease-in-out flex flex-col", { 'translate-x-0': _ctx.isOpen, 'translate-x-full': !_ctx.isOpen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex items-center" }, [
          _createElementVNode("h3", { class: "text-xl font-bold text-white" }, "Chat History")
        ], -1)),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          class: "p-2 bg-white/20 backdrop-blur-sm rounded-full text-white hover:bg-white/30 transition-colors border border-white/30 flex items-center justify-center",
          "aria-label": "Close chat history"
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })
          ], -1)
        ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createNewChat && _ctx.createNewChat(...args))),
        class: "w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors flex items-center justify-center"
      }, _cache[6] || (_cache[6] = [
        _createElementVNode("svg", {
          class: "w-5 h-5 mr-2",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
          })
        ], -1),
        _createTextVNode(" Create New Chat ")
      ]))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.userChats.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[7] || (_cache[7] = [
            _createElementVNode("svg", {
              class: "w-12 h-12 mx-auto text-gray-400 mb-3",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
              })
            ], -1),
            _createElementVNode("p", null, "No chat history found", -1)
          ])))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userChats, (chat) => {
        return (_openBlock(), _createElementBlock("div", {
          key: chat.id,
          onClick: ($event: any) => (_ctx.selectChat(chat.id)),
          class: _normalizeClass(["chat-item p-4 rounded-lg cursor-pointer transition-all duration-200 hover:bg-blue-50 relative group", { 'bg-blue-100 border-blue-300 border': _ctx.currentChatId === chat.id }])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("h4", _hoisted_8, _toDisplayString(chat.title), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.formatDate(chat.last_message_date)), 1)
            ]),
            _createElementVNode("button", {
              onClick: _withModifiers(($event: any) => (_ctx.confirmDeleteChat(chat.id)), ["stop"]),
              class: "text-gray-400 hover:text-red-500 transition-colors opacity-0 group-hover:opacity-100 absolute top-4 right-4",
              "aria-label": "Delete chat"
            }, _cache[8] || (_cache[8] = [
              _createElementVNode("svg", {
                class: "w-5 h-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                })
              ], -1)
            ]), 8, _hoisted_10)
          ])
        ], 10, _hoisted_6))
      }), 128))
    ]),
    (_ctx.showDeleteConfirm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 mb-4" }, "Delete Chat", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-gray-600 mb-6" }, "Are you sure you want to delete this chat? This action cannot be undone.", -1)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDeleteConfirm = false)),
                class: "px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteSelectedChat && _ctx.deleteSelectedChat(...args))),
                class: "px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
              }, " Delete ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}